// extracted by mini-css-extract-plugin
export default {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","large":"only screen and (min-width: 992px)","headerWrap":"_-0FwL","title":"_hqbP _1009a"};